<script setup lang="ts">
import { useRouter } from 'vue-router';
const router = useRouter();
</script>

<template>
  <div class="deny">
    <div class="card">
      <h1>403 · 越权访问</h1>
      <p>您当前角色无权访问该页面</p>
      <ElButton type="primary" @click="router.push('/dashboard')">返回工作台</ElButton>
    </div>
  </div>
</template>

<style scoped>
.deny {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}
.card {
  padding: 48px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
h1 {
  color: #e6a23c;
  margin: 0 0 16px;
}
</style>
